import { call, put, take, select } from 'redux-saga/effects'
import {
  storeLocally,
  removeLocally,
  getUserType,
  isResponseSuccessful,
  statusCodeIsBelow400,
  storeSession,
  readSession,
  removeSession,
  localToSessionStorage,
  sessionToLocalStorage,
} from '../helpers/utility'
//import api
import api from '../api/api'
//import aSync tracking for authentication actions
import { AUTH_ASYNC_CALL_START, AUTH_ASYNC_CALL_END } from '../actions/actions'
//import login actions
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL } from '../actions/actions'
import { LOGIN_AS_REQUEST, LOGIN_AS_SUCCESS, LOGIN_AS_FAIL } from '../actions/actions'
//import signup actions
import { LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAIL } from '../actions/actions'
//import signup actions
import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAIL } from '../actions/actions'
//import resetPass actions
import {
  RESET_PASS_REQUEST,
  RESET_PASS_SUCCESS,
  RESET_PASS_FAIL,
} from '../actions/actions'
//import resetPass actions
import {
  CONFIRM_RESET_PASS_REQUEST,
  CONFIRM_RESET_PASS_SUCCESS,
  CONFIRM_RESET_PASS_FAIL,
} from '../actions/actions'
import {
  RESET_PASSWORD_BY_SMS_REQUEST,
  RESET_PASSWORD_BY_SMS_SUCCESS,
  RESET_PASSWORD_BY_SMS_FAIL,
} from '../actions/actions'
import {
  CONFIRM_SMS_CODE_REQUEST,
  CONFIRM_SMS_CODE_SUCCESS,
  CONFIRM_SMS_CODE_FAIL,
} from '../actions/actions'

import { browserHistory } from 'react-router'
import { FETCH_USER_PROFILE } from '../actions/actions.js'
import { networkErrors } from '../helpers/consts'

export function* login() {
  while (true) {
    //note: login errors are returned as general_errors from the server
    const { username, password, reject } = yield take(LOGIN_REQUEST)
    yield put({ type: AUTH_ASYNC_CALL_START })
    //call the api for login
    try {
      const {
        data: {
          data: { user, token },
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.login, username, password)

      //fetch user profile if it is not a manager
      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: LOGIN_SUCCESS,
          token,
          userType: user.user_type && user.user_type.toUpperCase(),
          userId: user.id,
          email: user.email,
          username: user.username,
        })

        if (getUserType(user) !== 'MANAGER') {
          yield put({
            type: FETCH_USER_PROFILE,
            userType: user.user_type && user.user_type.toUpperCase(),
            userId: user.id,
          })
        }

        //persist in browser storage
        storeLocally(
          'fpAuth',
          JSON.stringify({
            token,
            userType: user.user_type && user.user_type.toUpperCase(),
            userId: user.id,
            email: user.email,
            username: user.username,
          })
        )

        // if ( getUserType(user) !== 'MANAGER' ) {
        //   window.location.href = '/'
        // }
      } else {
        yield put({ type: LOGIN_FAIL })
        reject({ form_errors, general_errors })
      }

      yield put({ type: AUTH_ASYNC_CALL_END })
    } catch (error) {
      reject({ general_errors: networkErrors.noConnection })
      yield put({ type: AUTH_ASYNC_CALL_END })
    }
  }
}

export function* loginAs() {
  while (true) {
    //note: login errors are returned as general_errors from the server
    const { resolve, reject } = yield take(LOGIN_AS_REQUEST)
    const { username } = yield select(state => state.profile.userInfo)

    // manager visited user's profile so data is there
    yield put({ type: AUTH_ASYNC_CALL_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.loginAs, username)

      const auth = {
        authenticated: true,
        token: data.token,
        userId: data.user.id,
        userType: data.user.user_type.toUpperCase(),
        username: data.user.username,
        email: data.user.email,
      }

      if (statusCodeIsBelow400(status)) {
        localToSessionStorage('fpAuth')
        storeLocally('fpAuth', JSON.stringify(auth))

        yield put({
          type: LOGIN_AS_SUCCESS,
          auth,
        })

        resolve()

        // persist in browser storage
        // storeLocally('fpAuth', JSON.stringify(auth))

      } else {
        yield put({ type: LOGIN_AS_FAIL })

        reject(errors)
      }

      yield put({ type: AUTH_ASYNC_CALL_END })
    } catch (error) {
      reject({ general_errors: ['اشکالی رخ داد ...'] })
      yield put({ type: AUTH_ASYNC_CALL_END })
    }
  }
}

export function* logout() {
  while (true) {
    yield take(LOGOUT_REQUEST)
    yield put({ type: AUTH_ASYNC_CALL_START })

    try {
      const loggedInAs = readSession('fpAuth')

      if(loggedInAs) {
        sessionToLocalStorage('fpAuth')
        removeSession('fpAuth')
      } else {
        removeLocally('fpAuth')
      }

      const response = yield call(api.logout)

      if (!response.error) {
        // browserHistory.push('/login')
        yield put({ type: LOGOUT_SUCCESS })

        // not sure if it should be after the above line or before
        window.location.href = loggedInAs ? '/dashboard' : '/'

      } else {
        yield put({ type: LOGOUT_FAIL })
      }

      yield put({ type: AUTH_ASYNC_CALL_END })
    } catch (error) {
      yield put({ type: AUTH_ASYNC_CALL_END })
    }
  }
}

export function* signup() {
  while (true) {
    const { formData, resolve, reject, userType } = yield take(SIGNUP_REQUEST)

    yield put({ type: AUTH_ASYNC_CALL_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.signup, formData, userType)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        const loggedInUserType = yield select(state => state.auth.userType)
        const userTypeLowerCase = userType.toLowerCase()
        const userTypeUpperCase = userType.toUpperCase() // just in case

        // needs some logic to separate real user signup from manager(admin) signups
        if (loggedInUserType === 'MANAGER') {
          yield put({
            type: `${userTypeUpperCase}_SIGNUP_BY_MANAGER_SUCCESS`,
            [userTypeLowerCase]: data[userTypeLowerCase],
          })

          resolve(data)
        } else {
          yield put({
            type: SIGNUP_SUCCESS,
            [userTypeLowerCase]: data[userTypeLowerCase],
          })

          resolve(data)
        }
      } else {
        yield put({ type: SIGNUP_FAIL })
        reject({ form_errors, general_errors })
      }

      yield put({ type: AUTH_ASYNC_CALL_END })
    } catch (error) {
      console.log(error)
      yield put({ type: SIGNUP_FAIL })
      yield put({ type: AUTH_ASYNC_CALL_END })
    }
  }
}

export function* resetPass() {
  while (true) {
    const { resolve, reject, formData } = yield take(RESET_PASS_REQUEST)
    yield put({ type: AUTH_ASYNC_CALL_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.resetPass, formData)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({ type: RESET_PASS_SUCCESS })
        resolve(data)
      } else {
        yield put({ type: RESET_PASS_FAIL })
        reject({ form_errors, general_errors })
      }

      yield put({ type: AUTH_ASYNC_CALL_END })
    } catch (error) {
      yield put({ type: AUTH_ASYNC_CALL_END })
    }
  }
}

export function* resetPassBySms() {
  while (true) {
    const { resolve, reject, formData } = yield take(RESET_PASSWORD_BY_SMS_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.resetPassBySms, formData)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({ type: RESET_PASSWORD_BY_SMS_SUCCESS, resetData: data })
        resolve(data)
      } else {
        yield put({ type: RESET_PASSWORD_BY_SMS_FAIL })
        reject({ ...form_errors, _error: general_errors })
      }
    } catch (error) {
      yield put({ type: RESET_PASSWORD_BY_SMS_FAIL, error })
    }
  }
}

export function* confirmResetPassBySms() {
  while (true) {
    const { resolve, reject, formData } = yield take(CONFIRM_SMS_CODE_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.confirmResetPassBySms, formData)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({ type: CONFIRM_SMS_CODE_SUCCESS })

        resolve(data)
      } else {
        yield put({ type: CONFIRM_SMS_CODE_FAIL })

        reject({ ...form_errors, _error: general_errors })
      }
    } catch (error) {
      yield put({ type: CONFIRM_SMS_CODE_FAIL, error })
    }
  }
}

export function* confirmResetPass() {
  while (true) {
    const { formData, resolve, reject } = yield take(CONFIRM_RESET_PASS_REQUEST)
    yield put({ type: AUTH_ASYNC_CALL_START })

    try {
      const {
        data: { data, errors, status },
      } = yield call(api.confirmResetPass, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({ type: CONFIRM_RESET_PASS_SUCCESS, data })
        resolve(data)
      } else {
        yield put({ type: CONFIRM_RESET_PASS_FAIL })
        reject(errors)
      }

      yield put({ type: AUTH_ASYNC_CALL_END })
    } catch (error) {
      yield put({ type: AUTH_ASYNC_CALL_END })
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/authenticationSaga.js